import React from 'react';
import { AppBar, Slide, useScrollTrigger } from '@material-ui/core';
import useStyles from './MobileHideOnScrollHeaderDrawer.style';

export interface MobileHideOnScrollHeaderDrawerProps {
  children: React.ReactElement;
  window?: () => Window;
}

function HideOnScroll(props: MobileHideOnScrollHeaderDrawerProps) {
  const { children, window } = props;
  const c = useStyles({});

  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    threshold: 50,
    disableHysteresis: false
  });

  return (
    <Slide
      appear={false}
      direction="down"
      in={!trigger}
      timeout={{
        enter: 200,
        exit: 200
      }}
    >
      <AppBar
        className={c.appBar}
        data-testid={'mobile-app-bar'}
        elevation={trigger ? 4 : 0}
      >
        {children}
      </AppBar>
    </Slide>
  );
}

const MobileHideOnScrollHeaderDrawer: React.FC<MobileHideOnScrollHeaderDrawerProps> = props => <HideOnScroll {...props} />;

export default MobileHideOnScrollHeaderDrawer;


